import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

export function provideTranslocoScopeFactoryCapabilitySuggest(): Provider {
  return provideTranslocoScope({
    scope: 'shared-factory-edit-capability-suggest',
    alias: 'factoryCapabilitySuggest',
    loader: i18nLoader,
  });
}
